module.exports = __webpack_public_path__ + "static/media/image-footer.d54718dc.svg";